import axios from "axios";

export const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API_BASE });

export const fetchContent = () => api.get("/content").then((r) => r.data);
export const fetchReleases = () => api.get("/releases").then((r) => r.data);
export const fetchVideos = () => api.get("/videos").then((r) => r.data);
export const fetchProducts = () => api.get("/products").then((r) => r.data);

export const joinPassport = (payload) =>
  api.post("/passport/join", payload).then((r) => r.data);

export const lookupPassport = (email) =>
  api.get(`/passport/lookup/${encodeURIComponent(email)}`).then((r) => r.data);

export const fanSignup = (payload) =>
  api.post("/fan-signup", payload).then((r) => r.data);

export const SHOPIFY_DOMAIN = process.env.REACT_APP_SHOPIFY_DOMAIN || "";
export const SHOPIFY_STOREFRONT_URL = SHOPIFY_DOMAIN ? `https://${SHOPIFY_DOMAIN}` : "";
export const SHOPIFY_COLLECTION_URL = SHOPIFY_DOMAIN
  ? `https://${SHOPIFY_DOMAIN}/collections/all`
  : "";

/** Send the visitor to the live XRABI Shopify storefront (new tab). */
export function openShopifyStorefront() {
  if (SHOPIFY_STOREFRONT_URL) {
    window.open(SHOPIFY_STOREFRONT_URL, "_blank", "noopener,noreferrer");
  }
}

/**
 * Official Shopify cart permalink. Real checkout happens on Shopify's secure
 * checkout where Apple Pay / Shop Pay / cards / supported crypto methods appear
 * natively. No payment is ever simulated on this site.
 */
export function shopifyCheckoutUrl(cartItems) {
  if (!SHOPIFY_DOMAIN) return null;
  const lines = cartItems
    .filter((i) => i.variantId)
    .map((i) => `${i.variantId}:${i.qty}`)
    .join(",");
  if (!lines) return null;
  return `https://${SHOPIFY_DOMAIN}/cart/${lines}`;
}

export function formatPrice(price, currency = "USD") {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency,
    maximumFractionDigits: price % 1 === 0 ? 0 : 2,
  }).format(price);
}
